<div class="divider" [ngStyle]="style" [attr.aria-orientation]="orientation" role="separator"></div>
